import { MapRepairPlanFilters } from "../../../../../stateManagement/reducers/maps/MapRepairPlan";
import { configureMapFiltersStateFromConfig } from "../filters/mapFiltersFunctions";
import { MapFiltersConfig } from "../filters/types";

export const mapFiltersConfig = [
    {
        caption: "Вид работ",
        type: "value",
        format: "list-checkbox",
        operation: "equals",
        hasSearch: false,
        canBeIgnored: true,
        canIncludeNull: false,
        fieldName: "RepairTypeStandartWorkType",
        values: [
            {
                caption: "Капитальный ремонт",
                value: 4,
                color: "#7030A0"
            },
            {
                caption: "Ремонт",
                value: 5,
                color: "#7F1734"
            },
            {
                caption: "Содержание",
                value: 16,
                color: "#414eff"
            },
        ],
    },
    {
        caption: "Район",
        minIrosVersionBuild: 6942,
        type: "value",
        format: "list-checkbox",
        operation: "equals",
        hasSearch: true,
        canBeIgnored: true,
        canIncludeNull: true,
        includeNull: false,
        fieldName: "RaionId",
        values: {
            url: "Dicts/Raions",
            propertyForCaption: "Name",
            propertyForValue: "RaionId",
            auth: "app",
        }
    }
] as const satisfies MapFiltersConfig;

export const initialMapFiltersState = configureMapFiltersStateFromConfig(mapFiltersConfig) as MapRepairPlanFilters
export const initialActiveTabs = configureMapFiltersStateFromConfig(mapFiltersConfig)